var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifyingGlassIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.258 62.156",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".magnifying_glass_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "magnifying_glass_icon_svg__a",
    d: "M6.958 35.678A20.3 20.3 0 101 21.313a20.313 20.313 0 005.958 14.365zM35.688 35.678l6.615 6.615M60.427 60.418a2.171 2.171 0 01-2.959 0L42.309 45.156a2.092 2.092 0 012.959-2.929l15.256 15.25a2.1 2.1 0 01-.097 2.941z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.052 24.375a.648.648 0 01-.14-.439 4.59 4.59 0 01.448-2.113 11.35 11.35 0 011.286-1.914 11.016 11.016 0 001.006-1.456 2.71 2.71 0 00.33-1.335 1.623 1.623 0 00-.619-1.346 2.638 2.638 0 00-1.672-.483 3.894 3.894 0 00-1.652.349 9.731 9.731 0 00-1.715 1.067 1.059 1.059 0 01-.551.239.457.457 0 01-.389-.209.819.819 0 01-.149-.488.933.933 0 01.308-.7 5.932 5.932 0 011.944-1.2 6.222 6.222 0 012.283-.458 4.337 4.337 0 012.8.857 2.754 2.754 0 011.069 2.253 3.547 3.547 0 01-.45 1.823 12.151 12.151 0 01-1.364 1.8 13.883 13.883 0 00-1.326 1.724 3.931 3.931 0 00-.569 1.724.481.481 0 01-.16.34.534.534 0 01-.358.119.457.457 0 01-.36-.16zm-.408 3.509a1.1 1.1 0 01-.308-.8 1.135 1.135 0 01.308-.808 1.1 1.1 0 011.575 0 1.135 1.135 0 01.308.808 1.1 1.1 0 01-.308.8 1.131 1.131 0 01-1.574-.001z",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifyingGlassIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/magnifying_glass_icon.77b3aec3c2cad9ca1e8186d30b1ba902.svg";